import Container_PhotoAreaComponent from '../components/Container/viewer/skinComps/PhotoArea/PhotoArea.skin';


const Container_PhotoArea = {
  component: Container_PhotoAreaComponent
};


export const components = {
  ['Container_PhotoArea']: Container_PhotoArea
};

